import { ToggleGroup, ToggleGroupItem } from '@components/ui/toggle-group'
import { COMMON_OFFSET_PRESETS } from '../constants/wrap-offsets'

interface OffsetPresetToggleProps {
  value: string | null
  disabled: boolean
  onSelect: (points: number) => void
}

/** Shared offset presets — applies one value to all four sides (of every selected target, each
 *  per its own style) at once (AC 2.2's four fields stay independently editable below; this is a
 *  convenience shortcut, not a link). */
export function OffsetPresetToggle({ value, disabled, onSelect }: OffsetPresetToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={value ?? ''}
      disabled={disabled}
      onValueChange={(val) => {
        if (!val) return
        onSelect(Number(val))
      }}
      className="justify-start gap-1 mt-1"
      variant="outline"
      size="sm"
    >
      {COMMON_OFFSET_PRESETS.map((pt) => (
        <ToggleGroupItem
          key={pt}
          value={pt.toString()}
          className="h-7 px-2 min-w-[2.5rem] text-xs font-medium leading-normal"
        >
          {pt}pt
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
